import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Store from '../../stores/Store'
import { FormInput } from 'semantic-ui-react'
import { observer } from 'mobx-react'

@observer
class Input extends Component {
  static propTypes = {
    ...FormInput.propTypes,
    store: PropTypes.instanceOf(Store).isRequired,
    name: PropTypes.string.isRequired,
    label: PropTypes.string,
    defaultValue: PropTypes.any,
    errorPointing: PropTypes.oneOf(['below', 'above', 'left']),
    castValue: PropTypes.func, // could be useful if you want to cast a value entered
    parseValue: PropTypes.func // could be useful if you want to parse value to form value
  }

  static defaultProps = {
    errorPointing: 'above'
  }

    handleOnChangeInput = e => {
      const { store, castValue } = this.props
      const value = castValue ? castValue(e.target.value) : e.target.value
      store.set(e.target.name, value)
      store.resetErrorMessageField(e.target.name)
    }

    render () {
      const {
        store,
        defaultValue,
        name,
        options,
        onChange,
        castValue,
        parseValue,
        errorPointing,
        error,
        ...props
      } = this.props
      const value = store.get(name, defaultValue ?? '')
      const valueError = store.getErrorMessageField(name)
      return (
        <FormInput
          value={parseValue ? parseValue(value) : value}
          name={name}
          error={valueError ? { content: valueError, pointing: errorPointing } : error}
          onChange={onChange || this.handleOnChangeInput}
          {...props}
        />
      )
    }
}
export default Input
